<template>
    <dx-form ref="formRef" v-model:form-data="roleLocalState.formData" label-mode="outside" label-location="top">
        <dx-group-item :col-count="4">
            <dx-simple-item
                :label="{ text: 'Приложение роли' }"
                :is-required="true"
                editor-type="dxSelectBox"
                data-field="appId"
                :editor-options="{
                    dataSource: roleLocalState.apps,
                    valueExpr: 'kod_app',
                    displayExpr: 'name_app',
                    onValueChanged: changedApp,
                }"
            />

            <dx-simple-item
                data-field="code"
                :label="{ text: 'Код' }"
                :editor-options="{ readOnly: isReadOnlyUiElement }"
            >
                <dx-async-rule :validation-callback="validateUniqueCode" message="Значение поля уже существует" />
                <dx-required-rule message="Поле должно быть заполнено" />
            </dx-simple-item>

            <dx-simple-item
                data-field="name"
                :is-required="true"
                :label="{ text: 'Название' }"
                :editor-options="{ readOnly: isReadOnlyUiElement }"
            />

            <dx-simple-item
                data-field="description"
                :label="{ text: 'Описание' }"
                :editor-options="{ readOnly: isReadOnlyUiElement }"
            />
        </dx-group-item>
    </dx-form>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import DxForm, { DxSimpleItem, DxGroupItem, DxRequiredRule, DxAsyncRule } from 'devextreme-vue/form';
import { validateCodeRole } from '@/service/admin-service';
import environmentData from '@/store/enviroment-data';
import roleLocalStore from '@/views/administration/roles/store.js';
import rolesStore from '@/store/administration/roles';

const { disableUiElement } = environmentData;
const { state: roleLocalState, MODE, UI_ELEMENTS_IDS, filterAreasByAppId } = roleLocalStore;
const { setRoleForm } = rolesStore;

const props = defineProps({
    readOnly: {
        type: Boolean,
        default: false,
    },
});

const formRef = ref('formRef');
const isReadOnlyUiElement = disableUiElement(UI_ELEMENTS_IDS.CARD) || props.readOnly;

onMounted(() => {
    setRoleForm(formRef.value);
    roleLocalState.formRef = formRef;
});

const validateUniqueCode = async (event) => {
    const currentCode = event ? event.value : roleLocalState.formData.code;
    return roleLocalState.mode === MODE.UPDATE && currentCode === roleLocalState.initialCode
        ? true
        : await validateCodeRole(currentCode);
};

const changedApp = event => {
    const currentAppId = event.value;
    filterAreasByAppId(currentAppId);
};

const formValidate = () => {
    return roleLocalState.formRef.instance?.validate();
};

defineExpose({
    validateUniqueCode,
    formValidate,
});
</script>
